// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/images/menu.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./components/images/hoagiesBackground3.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./components/images/Website_Banner_2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  background-color: black;
}
.App {
  /* text-align: center; */
  background-color: black;
}
.iconBar {
  background-color: white;
}
.iconBar,
p {
  font-size: x-large;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.blackBack {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  height: 50vh;
}
.aboutUs{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
}
.image {
  background-size: cover;
  height: 100%;
  padding: 10px;
  background-position: center center;
  background-repeat: no-repeat;
}
.banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  height: 40vh;
  background-position: center center;
  background-repeat: no-repeat;
}
.page-footer {
  background-color: black;
  color: white;
}
.glyphicon {
  padding: 10px;
  border-radius: 50px;
  background-color: rgb(255, 217, 0);
}
.heading {
  padding: 10px;
  border-radius:10px;
  background-color: rgb(255, 217, 0);
  font-size: 30pt;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  width:100%;
}
.heading2 {
  padding: 10px;
  border-radius: 10px;
  background-color: rgb(255, 217, 0);
  font-size: 15pt;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.t1 {
  text-decoration: none;
  color: rgb(255, 217, 0);
  font-size: 2.1em;
  margin-right: 20px;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.t1:hover {
  color: white;
}
.socials {
  height: 25px;
  width: 25px;
}
.media {
  margin: 1%;
  padding: 2%;
  border-radius: 50%;
  background-color: rgb(255, 217, 0);
  color: black;
  font-size: larger;
}
.mediaIcons{
  margin-bottom: 5px;
}
i {
  color: black !important;
}
#marker-example {
  border-radius: 20px;
  box-shadow: 1px 4px 4px 1px rgba(0, 0, 0, 0.5);
}

#marker-example:hover {
  box-shadow: 1px 4px 4px 1px rgba(0, 0, 0, 0.8);
}

.map {
  padding:25px;
}

.aboutUs {
  position: relative;
}

.form {
  padding: 10px;
  border-radius: 10px;
  background-color: rgb(255, 217, 0);
}

.formInput {
  background-color: white;
  color: darkslategrey;
}

.formInput:focus {
  background-color: rgb(100, 100, 100);
  color: rgb(255, 217, 0);
}
.link {
  color: white;
}
.link:hover {
  color: rgb(255, 217, 0);
}

.comingSoon {
  color: rgb(255, 217, 0);
  font-size: 75pt;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black !important;
}

.navBtn {
  border: 1px solid black !important;
}

.test {
  color: Black;
}

.card {
  border-radius: 20px;
  background-color: rgb(255, 217, 0);
}

.container {
  position: relative;
}

.box {
  width: 100%;
  left:0;
  height: 100%;
  position: absolute;
  opacity: 0.95;
  color: white;
}

.stack-top {
  background-color: rgb(112, 106, 69);
  z-index: 3;
}

.menuIcon {
  float: left;
  margin: auto;
}

hr {
  color: rgb(255, 217, 0);
}
.form {
  position: relative;
}

.alert {
  top: 0;
  height: 100%;
  position: absolute;
  color: rgb(255, 217, 0);
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black !important;
  background-color: rgb(75, 72, 52);
  width: 97%;
  opacity: 0.95;
  text-align: center;
  vertical-align: middle;
  line-height: 445%;
  border:10px solid black;
}
.alert #msg1 {
  font-size: 300%;
}
.error {
  top: 0;
  height: 100%;
  position: absolute;
  color: rgb(255, 217, 0);
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black !important;
  background-color: rgb(75, 72, 52);
  width: 97%;
  opacity: 0.95;
  text-align: center;
  vertical-align: middle;
  line-height: 445%;
  border:10px solid black;
}

.menuNew{
  color:white;
}

.btnAdd{
  background-color: rgb(255, 217, 0);
  color:black;
  font-weight: bolder;
  width: 140px;
}

.btnCustom{
  background-color: white;
  color:black;
  font-weight: bolder;
  width: 140px;
}
.menuCategory{
  width:50%;
  color: black;
  margin: 0 auto;
}

#aboutUs hr{
  color:black;
}

.tabs{
  color:white;
  background-color: black;
  border:1px solid rgb(255,217,0)
}

.tabs:hover{
  color:black;
  background-color: white;
  border:2px solid black;
}

.tabsActive{
  color:black;
  background-color: rgb(255,217,0);
  border:2px solid black;
}

.tab-back{
  background-color: black;
  color:black;
}
#tab{
  padding:2px;
  background-color: rgb(255,217,0);
  border-radius: 7px;
  font-size: 15pt;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.itemName{
  color: white;
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black !important;
}
.col {
  display: column;
}


.shake-slow{
  margin-left: 35%;
}
.navbar-nav {
  position:absolute;
  right:3%;
}
@media only screen and(min-width: 100px) and (max-width: 850px){
  .shake-slow{
    margin-left: -10%;
  }
  .navbar-nav {
    margin-left: 35%;
  }
}
@media only screen and(min-width: 851px) and (max-width: 1300px){
  .shake-slow{
    /* margin-left: 40%; */
  }
  .navbar-nav {
    margin-left: 10%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,sEAAsE;AACxE;AACA;EACE,yDAAsD;EACtD,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,yDAAoE;EACpE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,yDAAiE;EACjE,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,sEAAsE;EACtE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,sEAAsE;AACxE;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sEAAsE;AACxE;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sEAAsE;EACtE;8BAC4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB;8BAC4B;EAC5B,iCAAiC;EACjC,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB;8BAC4B;EAC5B,iCAAiC;EACjC,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,sEAAsE;AACxE;AACA;EACE,YAAY;EACZ;8BAC4B;AAC9B;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["html,\nbody {\n  background-color: black;\n}\n.App {\n  /* text-align: center; */\n  background-color: black;\n}\n.iconBar {\n  background-color: white;\n}\n.iconBar,\np {\n  font-size: x-large;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n}\n.blackBack {\n  background-image: url(\"./components/images/menu.webp\");\n  background-repeat: no-repeat;\n  background-position-x: center;\n  background-position-y: center;\n  height: 50vh;\n}\n.aboutUs{\n  background-image: url(\"./components/images/hoagiesBackground3.webp\");\n  background-position: center;\n}\n.image {\n  background-size: cover;\n  height: 100%;\n  padding: 10px;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.banner {\n  background-image: url(\"./components/images/Website_Banner_2.png\");\n  background-size: cover;\n  height: 40vh;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.page-footer {\n  background-color: black;\n  color: white;\n}\n.glyphicon {\n  padding: 10px;\n  border-radius: 50px;\n  background-color: rgb(255, 217, 0);\n}\n.heading {\n  padding: 10px;\n  border-radius:10px;\n  background-color: rgb(255, 217, 0);\n  font-size: 30pt;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n  width:100%;\n}\n.heading2 {\n  padding: 10px;\n  border-radius: 10px;\n  background-color: rgb(255, 217, 0);\n  font-size: 15pt;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n}\n.t1 {\n  text-decoration: none;\n  color: rgb(255, 217, 0);\n  font-size: 2.1em;\n  margin-right: 20px;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n}\n.t1:hover {\n  color: white;\n}\n.socials {\n  height: 25px;\n  width: 25px;\n}\n.media {\n  margin: 1%;\n  padding: 2%;\n  border-radius: 50%;\n  background-color: rgb(255, 217, 0);\n  color: black;\n  font-size: larger;\n}\n.mediaIcons{\n  margin-bottom: 5px;\n}\ni {\n  color: black !important;\n}\n#marker-example {\n  border-radius: 20px;\n  box-shadow: 1px 4px 4px 1px rgba(0, 0, 0, 0.5);\n}\n\n#marker-example:hover {\n  box-shadow: 1px 4px 4px 1px rgba(0, 0, 0, 0.8);\n}\n\n.map {\n  padding:25px;\n}\n\n.aboutUs {\n  position: relative;\n}\n\n.form {\n  padding: 10px;\n  border-radius: 10px;\n  background-color: rgb(255, 217, 0);\n}\n\n.formInput {\n  background-color: white;\n  color: darkslategrey;\n}\n\n.formInput:focus {\n  background-color: rgb(100, 100, 100);\n  color: rgb(255, 217, 0);\n}\n.link {\n  color: white;\n}\n.link:hover {\n  color: rgb(255, 217, 0);\n}\n\n.comingSoon {\n  color: rgb(255, 217, 0);\n  font-size: 75pt;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,\n    1px 1px 0 black !important;\n}\n\n.navBtn {\n  border: 1px solid black !important;\n}\n\n.test {\n  color: Black;\n}\n\n.card {\n  border-radius: 20px;\n  background-color: rgb(255, 217, 0);\n}\n\n.container {\n  position: relative;\n}\n\n.box {\n  width: 100%;\n  left:0;\n  height: 100%;\n  position: absolute;\n  opacity: 0.95;\n  color: white;\n}\n\n.stack-top {\n  background-color: rgb(112, 106, 69);\n  z-index: 3;\n}\n\n.menuIcon {\n  float: left;\n  margin: auto;\n}\n\nhr {\n  color: rgb(255, 217, 0);\n}\n.form {\n  position: relative;\n}\n\n.alert {\n  top: 0;\n  height: 100%;\n  position: absolute;\n  color: rgb(255, 217, 0);\n  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,\n    1px 1px 0 black !important;\n  background-color: rgb(75, 72, 52);\n  width: 97%;\n  opacity: 0.95;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 445%;\n  border:10px solid black;\n}\n.alert #msg1 {\n  font-size: 300%;\n}\n.error {\n  top: 0;\n  height: 100%;\n  position: absolute;\n  color: rgb(255, 217, 0);\n  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,\n    1px 1px 0 black !important;\n  background-color: rgb(75, 72, 52);\n  width: 97%;\n  opacity: 0.95;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 445%;\n  border:10px solid black;\n}\n\n.menuNew{\n  color:white;\n}\n\n.btnAdd{\n  background-color: rgb(255, 217, 0);\n  color:black;\n  font-weight: bolder;\n  width: 140px;\n}\n\n.btnCustom{\n  background-color: white;\n  color:black;\n  font-weight: bolder;\n  width: 140px;\n}\n.menuCategory{\n  width:50%;\n  color: black;\n  margin: 0 auto;\n}\n\n#aboutUs hr{\n  color:black;\n}\n\n.tabs{\n  color:white;\n  background-color: black;\n  border:1px solid rgb(255,217,0)\n}\n\n.tabs:hover{\n  color:black;\n  background-color: white;\n  border:2px solid black;\n}\n\n.tabsActive{\n  color:black;\n  background-color: rgb(255,217,0);\n  border:2px solid black;\n}\n\n.tab-back{\n  background-color: black;\n  color:black;\n}\n#tab{\n  padding:2px;\n  background-color: rgb(255,217,0);\n  border-radius: 7px;\n  font-size: 15pt;\n  font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif;\n}\n.itemName{\n  color: white;\n  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,\n    1px 1px 0 black !important;\n}\n.col {\n  display: column;\n}\n\n\n.shake-slow{\n  margin-left: 35%;\n}\n.navbar-nav {\n  position:absolute;\n  right:3%;\n}\n@media only screen and(min-width: 100px) and (max-width: 850px){\n  .shake-slow{\n    margin-left: -10%;\n  }\n  .navbar-nav {\n    margin-left: 35%;\n  }\n}\n@media only screen and(min-width: 851px) and (max-width: 1300px){\n  .shake-slow{\n    /* margin-left: 40%; */\n  }\n  .navbar-nav {\n    margin-left: 10%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
